module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kyushu-1-2210d568bfa64a465a8bdf4d9463e269.jpg";